import { ApplicableModel, ValidateJSModel, } from "forms/shared/types";
import { isPVQForm } from "helpers/form";

interface AffiliationModel {
  Explanation?: string
  ExplanationNotApplicable: ApplicableModel
}

export const affiliation: ValidateJSModel<AffiliationModel> = {
  Explanation: (value, attributes, attributeName, options) => {
    if (isPVQForm(options.formType) && attributes.ExplanationNotApplicable?.applicable !== false) {
      return {
        presence: true,
        hasValue: true
      }
    }
  }
}
